import { useEffect } from 'react'
import { Outlet, ScrollRestoration, useLocation } from 'react-router'
import { useTranslation } from 'react-i18next'
import { SearchDialog } from '@/components/SearchDialog'
import { BottomNav } from './BottomNav'
import { DemoNotice, MobileHeader, TopBar } from './Headers'
import { Sidebar } from './Sidebar'

export function AppShell() {
  const { t } = useTranslation()
  const { pathname } = useLocation()

  useEffect(() => {
    document.getElementById('content')?.focus({ preventScroll: true })
  }, [pathname])

  return (
    <div className="app-backdrop min-h-dvh">
      <a
        href="#content"
        className="sr-only z-50 rounded-lg bg-surface-1 px-4 py-2 focus:not-sr-only focus:fixed focus:top-3 focus:start-3"
      >
        {t('nav.skip')}
      </a>
      <Sidebar />
      <div className="md:ps-[76px] lg:ps-[264px]">
        <MobileHeader />
        <TopBar />
        <DemoNotice />
        <main
          id="content"
          tabIndex={-1}
          className="mx-auto w-full max-w-[1320px] px-4 pt-4 pb-28 outline-none md:px-6 md:pt-6 md:pb-12 lg:px-8"
        >
          <Outlet />
        </main>
      </div>
      <BottomNav />
      <SearchDialog />
      <ScrollRestoration />
    </div>
  )
}
